import React, { forwardRef, useMemo, useRef, useImperativeHandle } from 'react';
import DataForm from '../../../DataForm/src/index';
import { isFunc } from '../utils/Utils';
import { Button, Space } from '@tinper/next-ui';
const { Item: FormItem } = DataForm;

const FormContent = forwardRef(function FormContent (props, ref) {
  const { record, columns, validateTrigger, formProps = {}, index, onSaveRecord, onCancel, onValuesChange } = props;
  const editFormRef = useRef();
  useImperativeHandle(ref, () => {
    return {
      getFormInstance () {
        return editFormRef.current;
      }
    }
  })

  const FormItems = useMemo(() => {
    const items = [];
    function getFormItems (columns) {
      columns.forEach((item) => {
        const {
          editType = "input",
          data,
          pattern,
          patternMsg,
          validator,
          required,
          editOptions = {},
          formItemProps = {},
          htmlFor = "",
          renderFormItem,
          editAbled = true
        } = item;
        let isEditAbled = editAbled;
        if (typeof editAbled === 'function') {
          isEditAbled = editAbled(record, index, item);
        }
        const { rules = [] } = formItemProps;
        if (validator) {
          rules.push({
            validator: (rule, value) => {
              return new Promise((resolve, reject) => {
                validator(value, record, data, (msg) => {
                  if (!msg) {
                    reject(msg);
                  } else {
                    resolve(true);
                  }
                })
              })
            }
          })
        }
        if (required) {
          rules.push({ required: true, message: '必填项' });
        }
        if (pattern) {
          rules.push({ pattern, message: patternMsg });
        }

        /**
       * isEditAbled=true: 可编辑，但是如果不配置editType以及renderFormItem，默认editEype="input";
       * isEditAbled=true: 可编辑，配置editType以及renderFormItem，正常逻辑渲染;
       * isEditAbled=false:一票否决，不可编辑，不显示。
       */
        const formItemPropsRes = {
          ...formItemProps,
          ...editOptions,
          disabled: !isEditAbled,
          pattern,
          patternMsg,
          required,
          htmlFor,
          label: item.title,
          name: item.dataIndex,
          inputType: editType
        }

        if (isEditAbled && (!item.children || item.children.length === 0)) {
          if (renderFormItem && typeof renderFormItem === 'function') {
            items.push(<FormItem key={item.dataIndex} {...formItemPropsRes} inputType={"custom"} render={() => {
              return renderFormItem(editFormRef, record, index, item, isEditAbled);
            }}/>)
          } else {
            items.push(<FormItem key={item.dataIndex} {...formItemPropsRes} ></FormItem>);
          }
        }
        if (item.children) {
          getFormItems(item.children);
        }
      })
    }
    getFormItems(columns);

    return items;
  }, [columns])
  const values = useMemo(() => {
    const obj = {};
    columns.forEach((item) => {
      const { textToFormItemValue } = item;
      //   const showValue = dataToValue(editType, editOptions, record, item.dataIndex)
      let showValue = record[item.dataIndex];
      if (textToFormItemValue && isFunc(textToFormItemValue)) {
        showValue = textToFormItemValue(record[item.dataIndex], record, item, index);
      }

      obj[item.dataIndex] = showValue;
    });
    return obj;
  }, [columns, record])

  function onSaveData (e) {
    editFormRef.current.validateFields().then((data) => {
      console.log(data, record, index, "当前保存的行数据");
      onSaveRecord({ ...record, ...data }, record, index, e)
    })
  }

  const onCancelEdit = (e) => {
    onCancel(record, index, e);
  }

  console.log(values, "values")

  //  todo 控制实时更新单元格数据还是保存更新。
  return <div className="as-table-edit-pro-form-wrapper">
    <DataForm {...formProps} ref={editFormRef} values={values} validateTrigger={validateTrigger} onValuesChange={onValuesChange}>{FormItems}</DataForm>
    <div className='as-table-edit-pro-form-button'>
      <Space align="end">
        <Button onClick={onCancelEdit}>取消</Button>
        <Button colors="primary" onClick={onSaveData}>保存</Button>
      </Space>
    </div>
  </div>
})

export default FormContent